import { getObjectFromJSONString } from "../../Navigations/AddEntity/M_ManageEntityForm.helper";
const storageName = "navigationHistory";
export const getBreadCrumps = () => {
  let navigationHistory =
    getObjectFromJSONString(sessionStorage.getItem(storageName), "", []) || [];
  let [previous, current] = navigationHistory;
  return current && previous;
};

export const flushBreadCrumps = () => {
  sessionStorage.removeItem(storageName);
};

export const setBreadCrumps = (currentLocation) => {
  let tempCurrentLocation = { ...currentLocation };
  let navigationHistory =
    getObjectFromJSONString(sessionStorage.getItem(storageName), "", []) || [];
  let [previous, current] = navigationHistory;
  if (
    !tempCurrentLocation.pageUrl ||
    !tempCurrentLocation.crmId ||
    !tempCurrentLocation.templateId ||
    !tempCurrentLocation.title
  ) {
    return;
  }
  if (previous) {
    if (current) {
      let { url, title } = current;
      let [pageUrl, crmId, templateId] = url.slice(1).split("/");

      if (
        pageUrl !== tempCurrentLocation.pageUrl ||
        crmId !== tempCurrentLocation.crmId
      ) {
        let newRoute = {
          url: `/${tempCurrentLocation.pageUrl}/${tempCurrentLocation.crmId}/${tempCurrentLocation.templateId}`,
          title: tempCurrentLocation.title,
        };
        navigationHistory = [current, newRoute];
      } else if (
        templateId !== tempCurrentLocation.templateId ||
        title !== currentLocation.title
      ) {
        let newRoute = {
          url: `/${pageUrl}/${crmId}/${tempCurrentLocation.templateId}`,
          title: tempCurrentLocation.title,
        };
        navigationHistory = [previous, newRoute];
      }
    } else {
      let newRoute = {
        url: `/${tempCurrentLocation.pageUrl}/${tempCurrentLocation.crmId}/${tempCurrentLocation.templateId}`,
        title: tempCurrentLocation.title,
      };
      navigationHistory = [previous, newRoute];
    }
  } else {
    let newRoute = {
      url: `/${tempCurrentLocation.pageUrl}/${tempCurrentLocation.crmId}/${tempCurrentLocation.templateId}`,
      title: tempCurrentLocation.title,
    };
    navigationHistory = [newRoute];
  }

  sessionStorage.setItem(storageName, JSON.stringify(navigationHistory));
};

export const getBreadCrumpsV2 = () => {
  let navigationHistory =
    getObjectFromJSONString(sessionStorage.getItem(storageName), "", []) || [];
  let previousRouteIndex = navigationHistory.length - 2;
  return navigationHistory[previousRouteIndex];
};
export const routeBack = () => {
  let navigationHistory =
    getObjectFromJSONString(sessionStorage.getItem(storageName), "", []) || [];
  navigationHistory.pop();
  sessionStorage.setItem(storageName, JSON.stringify(navigationHistory));
};
// ─── Navigation History Panel helpers ────────────────────────────────────────
// Use native JSON.parse (no eval) so these functions are safe everywhere.

const safeReadHistory = () => {
  try {
    const raw = sessionStorage.getItem(storageName);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
};

/**
 * Returns the full history stack (all visited pages, oldest first).
 * Used by the NavigationHistory panel.
 */
export const getFullHistory = () => safeReadHistory();

/**
 * Trims sessionStorage history so that the clicked entry becomes the current
 * (last) entry.  Called when the user clicks an item in the history panel.
 */
export const trimHistoryToEntry = (targetPageUrl, targetCrmId, targetTemplateId) => {
  const history = safeReadHistory();
  const idx = history.findIndex(
    (e) =>
      e.pageUrl === targetPageUrl &&
      e.crmId === targetCrmId &&
      e.templateId === targetTemplateId
  );
  if (idx !== -1) {
    sessionStorage.setItem(storageName, JSON.stringify(history.slice(0, idx + 1)));
  }
};

// ─────────────────────────────────────────────────────────────────────────────

export const setBreadCrumpsV2 = (currentNavigation) => {
  let navigationHistory =
    getObjectFromJSONString(sessionStorage.getItem(storageName), "", []) || [];
  let { pageUrl, crmId, templateId, title } = currentNavigation;
  if (!pageUrl || !crmId || !templateId) {
    return "Invalid Route";
  }
  if (!title || title === "") {
    currentNavigation.title = pageUrl;
  }
  let routesDetails = [...navigationHistory];
  let tempCurrentNavigation = currentNavigation;
  let lastIndex = routesDetails.length - 1;
  let current = routesDetails[lastIndex];
  if (current) {
    if (
      current.pageUrl !== tempCurrentNavigation.pageUrl ||
      current.crmId !== tempCurrentNavigation.crmId
    ) {
      // Remove any earlier duplicate of this page (move-to-top dedup)
      routesDetails = routesDetails.filter(
        (e) =>
          !(
            e.pageUrl === tempCurrentNavigation.pageUrl &&
            e.crmId === tempCurrentNavigation.crmId
          )
      );
      routesDetails.push(tempCurrentNavigation);
    } else if (
      current.templateId &&
      tempCurrentNavigation.templateId &&
      current.templateId !== tempCurrentNavigation.templateId
    ) {
      routesDetails[routesDetails.length - 1] = tempCurrentNavigation;
    } else if (
      current.pageUrl === tempCurrentNavigation.pageUrl &&
      current.crmId === tempCurrentNavigation.crmId &&
      current.title !== tempCurrentNavigation.title
    ) {
      routesDetails[routesDetails.length - 1].title = tempCurrentNavigation.title;
    }
  } else {
    routesDetails.push(tempCurrentNavigation);
  }
  // Keep at most 10 entries so the history panel never shows stale data
  if (routesDetails.length > 10) {
    routesDetails = routesDetails.slice(routesDetails.length - 10);
  }
  sessionStorage.setItem(storageName, JSON.stringify(routesDetails));
};
